module.exports = __webpack_public_path__ + "static/media/doubleShot.38685e81.mp3";